"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_final_form_1 = require("react-final-form");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const context_1 = require("context");
const lock_svg_1 = __importDefault(require("images/utility-icons/lock.svg"));
const utils_1 = require("utils");
const ProveFindForm = ({ skipFunc, submitFunc, onSubmitFail, onSubmitSuccess, }) => {
    // Hooks
    const location = (0, react_router_dom_1.useLocation)(); // location.state
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    // Vars
    const prefill_ota_phone = location.state?.personalInfo?.primaryPhone ?? '';
    // State
    const [isSuccessful, setIsSuccessful] = (0, react_1.useState)(false);
    const [hasErr, setHasErr] = (0, react_1.useState)(false);
    /**
     * @name formValidate
     * @param values
     * @returns
     */
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (!values.ssn) {
                errors.ssn = 'Last 4 of SSN Required';
            }
            if (values.ssn && values.ssn.length < 4) {
                errors.ssn = 'Invalid SSN';
            }
            if (!values.phone) {
                errors.phone = 'Phone Number Required';
            }
            if (values.phone && (0, utils_1.validatePhoneNumber)(values.phone)) {
                errors.phone = 'Invalid Phone Number';
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    /**
     * @name formSubmit
     * @param values
     * @returns
     */
    const formSubmit = async (values) => {
        // Submitted Values
        if (values) {
            //do something useful
            const isFormValid = formValidate(values);
            // Is form valid
            if (isFormValid === undefined) {
                // Form is valid
                const res = await submitFunc({
                    phone: values.phone.replace(/[^0-9]/g, ''),
                    ssn_last_4: values.ssn,
                });
                if (res) {
                    const jsonRes = await res.json();
                    if (jsonRes.session_id &&
                        jsonRes.phone_number &&
                        jsonRes.ssn_last_4) {
                        onSubmitSuccess(jsonRes);
                        setIsSuccessful(true);
                    }
                    else {
                        setIsSuccessful(false);
                        if (jsonRes.message) {
                            setHasErr(jsonRes.message);
                        }
                        onSubmitFail(jsonRes);
                    }
                }
                else {
                    const submitErr = 'Sorry, there was an error submitting the form';
                    setHasErr(submitErr);
                    onSubmitFail(submitErr);
                }
                return undefined;
            }
            else {
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    };
    /**
     * @name handleSkipButton
     */
    const handleSkipButton = () => {
        analytics?.track('ClickIDontHaveMobileNumber', {});
        skipFunc();
    };
    (0, react_1.useEffect)(() => {
        if (hasErr) {
            handleSkipButton();
        }
    }, [hasErr, location]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "max-width-600 margin-auto", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)("h2", { className: "font-family-bold", children: "Let's Find Your Information" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "p-20 text-left mar-y-20", children: "Providing the below information can auto-fill your pre-qualification." }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { className: "form-shell", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: {
                                    phone: prefill_ota_phone,
                                }, onSubmit: formSubmit, validate: formValidate, render: ({ handleSubmit, pristine, submitting }) => {
                                    // Button Disabled Bool
                                    const btnDisabled = submitting || isSuccessful;
                                    return ((0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)("div", { className: "form-row align-start", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "phone", disabled: isSuccessful || prefill_ota_phone !== '', label: `Mobile Number`, component: components_1.InputPattern, allowEmptyFormatting: false, formattype: '(###)-###-####', isAllowed: (values) => {
                                                        const { floatValue, value, formattedValue } = values;
                                                        return (value.length <= 14 ||
                                                            (value === '' &&
                                                                formattedValue === '' &&
                                                                floatValue === undefined));
                                                    }, placeholder: "Enter your phone", validate: utils_1.validateRequiredField, required: true, hinttype: (0, jsx_runtime_1.jsxs)("div", { className: "input-text-hint mar-y-10", children: ["By providing your phone number, Alphaeon Credit and their service providers may contact you at any number you provide, including by autodialer, recorded or artificial voice, and text. Message frequency varies. Message and data rates may apply. For further details, refer to our", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, config_1.makePath)(config_1.PATH.LEGAL, config_1.PATH.CONSENT_AUTODIALED), target: "_blank", className: "font-weight-400", rel: "noreferrer", children: "Consent to Autodialed Calls/Texts" }), ' ', "and", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, config_1.makePath)(config_1.PATH.LEGAL, config_1.PATH.WIRELESS_CARRIER_TERMS), target: "_blank", className: "font-weight-400", rel: "noreferrer", children: "Wireless Carrier Disclosure" }), ' ', "terms."] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "form-row align-start", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "ssn", disabled: isSuccessful, label: `Last 4 of SSN`, component: components_1.InputNumber, placeholder: "Enter the last 4 of SSN", hiddenicon: 'true', required: true, validate: utils_1.validateRequiredField, isAllowed: (values) => {
                                                        const { floatValue, value, formattedValue } = values;
                                                        return (value.length <= 4 ||
                                                            (value === '' &&
                                                                formattedValue === '' &&
                                                                floatValue === undefined));
                                                    }, hinttype: (0, jsx_runtime_1.jsxs)("div", { className: "flex space-between mar-y-10", children: [(0, jsx_runtime_1.jsx)("div", { className: "icon-container", children: (0, jsx_runtime_1.jsx)("img", { src: lock_svg_1.default, alt: "lock icon" }) }), (0, jsx_runtime_1.jsx)("div", { children: "\u00A0\u00A0" }), (0, jsx_runtime_1.jsx)("div", { className: "w100", children: (0, jsx_runtime_1.jsx)("p", { className: "p-16 color-gray", children: "We use your social security number to validate your information and check your credit. Your information is transmitted securely." }) })] }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-col text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "send-receipt-buttons", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", "data-testid": "access-form-submit-button", className: `send-receipt-modal-btn button-primary button-warn-outline ${btnDisabled ? 'is-disabled' : 'is-enabled'} ${submitting ? 'in-progress' : ''}`, "aria-disabled": btnDisabled && !(pristine || submitting), children: btnDisabled
                                                                ? isSuccessful
                                                                    ? 'Success!'
                                                                    : '...Submitting'
                                                                : `Continue` }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", "data-testid": "access-form-skip-button", onClick: handleSkipButton, className: `send-receipt-modal-btn text-red button-secondary-outline border-none`, children: "I don't have a mobile number" }) })] })] }));
                                } }) })] })] }) }));
};
exports.default = ProveFindForm;
